import { FieldErrors } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Text } from '@/lib/v2/components';

import GroupContactsDropdown from '@/modules/RulesModule/components/FormRule/components/GroupContactsDropdown';
import { TRANSLATE_RULES_LABELS } from '@/modules/RulesModule/constants';
import { IFormProps, IRuleForm } from '@/modules/RulesModule/interfaces';

interface IGroupContactsProps {
  errors: FieldErrors<IRuleForm>;
  form: IFormProps<IRuleForm>;
  disabled?: boolean;
}

const GroupContacts = ({ form, errors, disabled = false }: IGroupContactsProps) => {
  const { t } = useTranslation('rules');

  return (
    <div className="mb-5 mr-8 w-full">
      <Text className="mr-2 whitespace-nowrap" fontWeight="medium" variant="text">
        {t(`${TRANSLATE_RULES_LABELS}.groupContacts`)}
      </Text>
      <GroupContactsDropdown disabled={disabled} errors={errors} form={form} />
      {errors.groupContacts?.message && typeof errors.groupContacts.message === 'string' && (
        <Text color="alert" variant="text-sm">
          {errors.groupContacts.message}
        </Text>
      )}
    </div>
  );
};

export default GroupContacts;
